export default "__VITE_ASSET__DAbZuRF4__"